var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7502 21C12.7502 21.414 12.4142 21.75 12.0002 21.75H8.00024C5.38124 21.75 3.25024 19.619 3.25024 17V7C3.25024 4.381 5.38124 2.25 8.00024 2.25H12.0002C12.4142 2.25 12.7502 2.586 12.7502 3C12.7502 3.414 12.4142 3.75 12.0002 3.75H8.00024C6.20824 3.75 4.75024 5.208 4.75024 7V17C4.75024 18.792 6.20824 20.25 8.00024 20.25H12.0002C12.4142 20.25 12.7502 20.586 12.7502 21ZM20.5302 11.47L16.5302 7.46997C16.2372 7.17697 15.7622 7.17697 15.4692 7.46997C15.1762 7.76297 15.1762 8.23801 15.4692 8.53101L18.1892 11.251H10.0002C9.58624 11.251 9.25024 11.587 9.25024 12.001C9.25024 12.415 9.58624 12.751 10.0002 12.751H18.1892L15.4692 15.4709C15.1762 15.7639 15.1762 16.239 15.4692 16.532C15.6152 16.678 15.8072 16.752 15.9992 16.752C16.1912 16.752 16.3832 16.679 16.5292 16.532L20.5292 12.532C20.8232 12.237 20.8232 11.763 20.5302 11.47Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.e9d17b87.svg";
export { ForwardRef as ReactComponent };